import * as forms from '@/libraries/forms/forms'
import { CameraUpload } from '@/libraries/model/model'
import { store } from '@/store/store.js'

const fields = [
  new forms.FormField({
    type: forms.FormFieldType.TEXT,
    identifier: 'name',
    label: 'Name',
    placeholder: 'New Camera',
    defaultValue: 'New Camera',
  }),
  new forms.FormField({
    type: forms.FormFieldType.TEXT,
    identifier: 'protocol',
    label: 'Protocol',
    placeholder: 'rtsp://',
  }),
  new forms.FormField({
    type: forms.FormFieldType.TEXT,
    identifier: 'hostname',
    label: 'Host Address',
    placeholder: '192.168.0.1',
  }),
  new forms.FormField({
    type: forms.FormFieldType.NUMBER,
    identifier: 'port',
    label: 'Port',
    placeholder: '554',
    default: '554',
  }),
  new forms.FormField({
    type: forms.FormFieldType.TEXT,
    identifier: 'username',
    label: 'Username',
    placeholder: 'admin',
    defaultValue: 'admin',
  }),
  new forms.FormField({
    type: forms.FormFieldType.PASSWORD,
    identifier: 'password',
    label: 'Password',
    placeholder: '••••',
  }),
  new forms.FormField({
    type: forms.FormFieldType.NUMBER,
    identifier: 'channel',
    label: 'Channel',
    placeholder: '1',
  }),
  new forms.FormField({
    type: forms.FormFieldType.CHECKBOX,
    identifier: 'stream',
    label: 'Stream',
    placeholder: 'Please Choose One Or More',
    defaultValue: '',
    options: [
      new forms.FormFieldSelectOption('High Resolution', 1),
      new forms.FormFieldSelectOption('Low Resolution', 2),
    ],
    multiselect: true }),
]

export const floorTokenizerParameters = {
  tokenizer: new forms.FormTemplateRuleParameter({
    identifier: 'token',
    type: forms.FormTemplateRuleParameterType.TOKENIZER,
    source: new forms.FormTemplateRuleTokenizer('Floor Number', forms.regex.FLOOR_NUMBER),
  }),
  start: new forms.FormTemplateRuleParameter({
    identifier: 'start',
    type: forms.FormTemplateRuleParameterType.TOKENIZER,
    source: new forms.FormTemplateRuleTokenizer('Floor Number', forms.regex.FLOOR_NUMBER),
  }),
}

const rules = [
  new forms.DuplicateRule(),
  new forms.SequentialValueRule(floorTokenizerParameters),
  new forms.FormTemplateRule('Convert Hikvision To API Format', function (submission, index, parameters) {
    const channel = submission.fields.channel
    const stream = submission.fields.stream

    const camera = new CameraUpload({
      currentDomainId: store.getters.currentDomainUUID,
      name: submission.fields.name,
      uuid: submission.fields.uuid, // Plan is that empty UUID means "create" otherwise, pass back the inital one.
      protocol: submission.fields.protocol,
      hostname: submission.fields.hostname,
      port: submission.fields.port,
      username: submission.fields.username,
      password: submission.fields.password,
      path: '/Streaming/Channels/' + channel + '0' + stream,
    })

    return camera
  }),
  // new forms.EnsureArrayRule()
]
const template = new forms.FormTemplate('Advanced Settings', rules)

export const form = new forms.Form('Hikvision', fields, template)
